"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getStyleTag;

var _stylis = require("stylis");

var _StyleCollector = _interopRequireDefault(require("./StyleCollector"));

var _jsxRuntime = require("react/jsx-runtime");

/**
 * Returns `<style />` tag expected by SX. It can be used for SSR of the styles but it can also be
 * omitted completely if you don't care about SSR.
 */
function getStyleTag() {
  var createStylesMarkup = function createStylesMarkup() {
    var cssStyles = (0, _stylis.serialize)((0, _stylis.compile)(_StyleCollector.default.print()), (0, _stylis.middleware)([_stylis.prefixer, _stylis.stringify]));
    return {
      __html: cssStyles
    };
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("style", {
    "data-adeira-sx": true // https://reactjs.org/docs/dom-elements.html#dangerouslysetinnerhtml
    ,
    dangerouslySetInnerHTML: createStylesMarkup()
  });
}